import Service from "../Service";

const resource = "ExtCommercialProgramming/";

export default {
  pagination(filter, requestID) {
    return Service.post(resource + "pagination", filter, {
      params: { requestID: requestID },
    });
  },

  getById(id, requestID) {
    return Service.post(resource + "getById", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  getDetails(id, requestID) {
    return Service.post(resource + "getDetails", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  getLockedBudgets(filter, requestID) {
    return Service.post(resource + "getLockedBudgets", filter, {
      params: { requestID: requestID },
    });
  },

  getBudgetCustomersAvailability(filter, requestID) {
    return Service.post(resource + "getBudgetCustomersAvailability", filter, {
      params: { requestID: requestID },
    });
  },

  summaryByCustomer(id, requestID) {
    return Service.post(resource + "summaryByCustomer", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID: requestID },
    });
  },

  activate(id, requestID) {
    return Service.post(resource + "activate", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  close(id, requestID) {
    return Service.post(resource + "close", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  cancel(id, requestID) {
    return Service.post(resource + "cancel", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  getUnassignedAllocationSummary(embId, requestID, ecpId = null) {
    return Service.get(resource + "unassignedAllocationSummary", {
      params: { embId: embId, requestID: requestID, ecpId: ecpId },
    });
  },

  getUnassignedAllocationHistory(embId, requestID, ecpId = null) {
    return Service.get(resource + "unassignedAllocationHistory", {
      params: { embId: embId, requestID: requestID, ecpId: ecpId },
    });
  },

  allocateUnassignedBudget(obj, requestID) {
    return Service.post(resource + "allocateUnassignedBudget", obj, {
      params: { requestID: requestID },
    });
  },

  cancelUnassignedAllocation(obj, requestID) {
    return Service.post(resource + "cancelUnassignedAllocation", obj, {
      params: { requestID: requestID },
    });
  },

  getLineHeaders(isView = false) {
    const headers = [
      { text: "#", value: "index", align: "center", sortable: false, width: "45px" },
      { text: "Cliente Comercial (SAP)", value: "client", sortable: false, width: "200px" },
      { text: "Ejecutivo", value: "executive", sortable: false, width: "130px" },
      { text: "Producto *", value: "product", sortable: false, width: "150px" },
      { text: "Marca", value: "brand", sortable: false, width: "120px" },
      { text: "Empaque", value: "packaging", sortable: false, width: "130px" },
      { text: "Tipo", value: "commercialType", sortable: false, width: "110px" },
      { text: "Incoterm", value: "incoterm", sortable: false, width: "110px" },
      { text: "Puerto / Destino", value: "portDestination", sortable: false, width: "130px" },
      { text: "TM Prog.", value: "programmedTons", align: "right", sortable: false, width: "110px" },
      { text: "FCL Prog.", value: "programmedFcl", align: "right", sortable: false, width: "100px" },
      { text: "P. Pactado ($/kg)", value: "priceAgreed", align: "right", sortable: false, width: "110px" },
      { text: "P. FOB Eq ($/kg)", value: "priceFobEquivalent", align: "right", sortable: false, width: "110px" },
      { text: "FOB Eq Total", value: "amountFobEquivalent", align: "right", sortable: false, width: "120px" },
      { text: "Estado", value: "status", align: "center", sortable: false, width: "95px" },
    ];

    if (!isView) {
      headers.push({ text: "Acciones", value: "actions", align: "center", sortable: false, width: "90px" });
    }

    return headers;
  },

  getCustomerDetailLineHeaders(isView = false) {
    const headers = [
      { text: "#", value: "index", align: "center", sortable: false, width: "45px" },
      { text: "Producto *", value: "product", sortable: false, width: "150px" },
      { text: "Marca", value: "brand", sortable: false, width: "120px" },
      { text: "Empaque", value: "packaging", sortable: false, width: "130px" },
      { text: "Tipo", value: "commercialType", sortable: false, width: "100px" },
      { text: "Incoterm", value: "incoterm", sortable: false, width: "100px" },
      { text: "Puerto / Destino", value: "portDestination", sortable: false, width: "130px" },
      { text: "TM Prog.", value: "programmedTons", align: "right", sortable: false, width: "110px" },
      { text: "FCL Prog.", value: "programmedFcl", align: "right", sortable: false, width: "100px" },
      { text: "P. Pactado ($/kg)", value: "priceAgreed", align: "right", sortable: false, width: "110px" },
      { text: "P. FOB Eq ($/kg)", value: "priceFobEquivalent", align: "right", sortable: false, width: "110px" },
      { text: "FOB Eq Total", value: "amountFobEquivalent", align: "right", sortable: false, width: "120px" },
      { text: "Estado", value: "status", align: "center", sortable: false, width: "95px" },
    ];

    if (!isView) {
      headers.push({ text: "Acciones", value: "actions", align: "center", sortable: false, width: "90px" });
    }

    return headers;
  },

  getSummaryHeaders() {
    return [
      { text: "Cliente Comercial", value: "CustomerName", sortable: true, width: "200px" },
      { text: "Ppto TM", value: "BudgetTons", align: "right", sortable: true, width: "100px" },
      { text: "Prog. TM", value: "ProgrammedTons", align: "right", sortable: true, width: "110px" },
      { text: "Saldo TM", value: "BalanceTons", align: "right", sortable: true, width: "110px" },
      { text: "Ppto FCL", value: "BudgetFcl", align: "right", sortable: true, width: "90px" },
      { text: "Prog. FCL", value: "ProgrammedFcl", align: "right", sortable: true, width: "90px" },
      { text: "Saldo FCL", value: "BalanceFcl", align: "right", sortable: true, width: "90px" },
      { text: "Ppto FOB USD", value: "BudgetFobUsd", align: "right", sortable: true, width: "120px" },
      { text: "Prog. FOB USD", value: "ProgrammedFobUsd", align: "right", sortable: true, width: "120px" },
      { text: "Saldo FOB USD", value: "BalanceFobUsd", align: "right", sortable: true, width: "120px" },
      { text: "Imp. Contractual", value: "AmountContract", align: "right", sortable: true, width: "130px" },
      { text: "Líneas", value: "LineCount", align: "center", sortable: true, width: "80px" },
    ];
  },
};
